import React from "react";
import { CheckboxProps } from "antd/lib/checkbox";

import { StyledCheckbox } from "./checkbox.style";
import "./checkbox.less";

export const Checkbox: React.FC<CheckboxProps> = (props) => <StyledCheckbox {...props} />;
